/**
 * The API can return placeholder strings when the customer has no first/last
 * name (e.g. "null null", "null", "undefined undefined"). Turn those into an
 * empty string so the input stays empty and the user can type their own name.
 */
const sanitizeName = (name) => {
    if (typeof name !== "string") return "";
    const cleaned = name
        .split(/\s+/)
        .filter((part) => part && part !== "null" && part !== "undefined")
        .join(" ")
        .trim();
    return cleaned;
};

export default sanitizeName;
